import { createReducer } from 'redux-act';
// import moment from 'moment';

import {
  MEDIA_FETCH_DATA_INIT,
  MEDIA_FETCH_DATA_SUCCESS,
  MEDIA_FETCH_DATA_FAIL,
  MEDIA_DELETE_MEDIA_INIT,
  MEDIA_DELETE_MEDIA_SUCCESS,
  MEDIA_DELETE_MEDIA_FAIL,
  BULK_MEDIA_DELETE_INIT,
  BULK_MEDIA_DELETE_SUCCESS,
  BULK_MEDIA_DELETE_FAIL,
  MEDIA_CLEAR_DATA,
  MEDIA_CREATE_MEDIA_INIT,
  MEDIA_CREATE_MEDIA_SUCCESS,
  MEDIA_CREATE_MEDIA_FAIL,
  MEDIA_MODIFY_MEDIA_INIT,
  MEDIA_MODIFY_MEDIA_SUCCESS,
  MEDIA_MODIFY_MEDIA_FAIL,
  MEDIA_CLEAN_UP,
  MEDIA_CLEAR_DATA_LOGOUT,
  MEDIA_BULK,
  SET_MEDIA,
  ORDER_MEDIA,
  MEDIA_ADD_MEDIA_GROUP,
} from 'state/actions/media';

const initialState = {
  list: [],
  media: {
    // this is the old one, Imma change it with a new one
    // name: '',
    // description: '',
    // start: '',
    // end: '',
    // duration: 5,
    // fileUrl: null,
    // siteId: '',
    // modifiedAt: moment(Date.now()).format('DD-MM-YY hh:mm:ss'),
    // modifiedBy: '',
    // type: 'all',
    // dates: [],
    // color: '#000000',
    // fileType: '',
    days: [],
    name: '',
    description: '',
    categoryList: [],
    siteId: '',
    file: '',
    isRemoved: false,
    duration: 10,
    start: null,
    end: null,
  },
  mediaGroup: null,
  loading: false,
  error: {
    errors: null,
    messsage: '',
  },
  success: false,
  deleted: false,
  updated: false,
};

export const mediaReducer = createReducer(
  {
    [MEDIA_FETCH_DATA_INIT]: (state) => ({
      ...initialState,
      loading: true,
      mediaGroup: state.mediaGroup,
    }),
    [MEDIA_FETCH_DATA_SUCCESS]: (state, payload) => {
      const groupMediaData = (data) => {
        if (!data || !Array.isArray(data)) {
          return [];
        }

        // Strip UUID prefix from logo filename
        const stripUuid = (logo) => {
          if (!logo) return '';
          return logo.replace(
            /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i,
            ''
          );
        };

        const buckets = data.reduce((acc, item) => {
          const key = `${item.name}::${stripUuid(item.logo)}`;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(item);
          return acc;
        }, {});

        return Object.values(buckets).flatMap((items) => {
          if (items.length === 1) {
            return items[0];
          }

          const latest = items.reduce((a, b) =>
            (b.modifiedAt || 0) > (a.modifiedAt || 0) ? b : a
          );

          const uniqueType = new Set(items.map((i) => i.type));
          const uniqueStart = new Set(items.map((i) => i.start || null));
          const uniqueEnd = new Set(items.map((i) => i.end || null));

          const hasVariousSchedule =
            uniqueType.size > 1 || uniqueStart.size > 1 || uniqueEnd.size > 1;

          const uniqueDuration = new Set(items.map((i) => i.duration || null));

          const hasVariousDuration = uniqueDuration.size > 1;

          const base = {
            _id: items[0]._id,
            name: items[0].name,
            description: items[0].description,
            siteId: items[0].siteId,
            logo: items[0].logo,
            schedulingType: items[0].schedulingType,
            fileType: items[0].fileType,
            directoryId: items[0].directoryId,
            duration: items[0].duration,
            approval: items[0].approval,
            status: items[0].status,
            modifiedAt: latest.modifiedAt,
            modifiedBy: latest.modifiedBy,
            grouped: [],
          };

          if (!hasVariousSchedule) {
            base.type = items[0].type;
            if (items[0].start !== undefined) base.start = items[0].start;
            if (items[0].end !== undefined) base.end = items[0].end;
          } else {
            base.variousSchedule = true;
          }

          if (hasVariousDuration) {
            base.variousDuration = true;
          }

          base.grouped = items.map((item) => {
            const entry = { ...item };

            if (hasVariousSchedule) {
              entry.type = item.type;
              if (item.start !== undefined) entry.start = item.start;
              if (item.end !== undefined) entry.end = item.end;
            }

            return entry;
          });

          return base;
        });
      };

      const listData = payload.list || [];
      const isAllCategory = payload.categoryId === 'all';
      const finalList = isAllCategory ? groupMediaData(listData) : listData;

      return {
        ...state,
        list: finalList,
        media: payload.media || initialState.media,
        loading: false,
        error: {
          errors: null,
          messsage: '',
        },
      };
    },
    [MEDIA_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [MEDIA_DELETE_MEDIA_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [MEDIA_DELETE_MEDIA_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem.id !== payload.id),
      loading: false,
      error: {
        errors: null,
        messsage: '',
      },
      deleted: true,
      updated: true,
    }),
    [MEDIA_DELETE_MEDIA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [BULK_MEDIA_DELETE_INIT]: (state) => ({
      ...state,
      deleted: false,
      loading: true,
    }),
    [BULK_MEDIA_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((md) => {
        // eslint-disable-line
        if (payload.data.every((fd) => fd !== md._id)) {
          return md;
        }
        return false;
      }),
      loading: false,
      error: {
        errors: null,
        messsage: '',
      },
      deleted: true,
      updated: true,
    }),
    [BULK_MEDIA_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      deleted: false,
      error: payload.error,
    }),
    [MEDIA_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [MEDIA_CREATE_MEDIA_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [MEDIA_CREATE_MEDIA_SUCCESS]: (state, payload) => ({
      ...state,
      list: [...state.list, ...payload.media],
      loading: false,
      error: {
        errors: null,
        messsage: '',
      },
      success: true,
      updated: true,
    }),
    [MEDIA_CREATE_MEDIA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [MEDIA_MODIFY_MEDIA_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [MEDIA_MODIFY_MEDIA_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem.id === payload.id) {
              return {
                id: payload.id,
                name: payload.media.name,
                description: payload.media.description,
                start: payload.media.start,
                end: payload.media.end,
                duration: payload.media.duration,
                fileUrl: payload.media.fileUrl,
                siteId: payload.media.siteId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.media.modifiedBy,
                type: payload.media.type,
                fileType: payload.media.fileType,
                color: payload.media.color,
              };
            }
            return elem;
          }),
      loading: false,
      error: {
        errors: null,
        messsage: '',
      },
      success: true,
      updated: true,
    }),
    [MEDIA_MODIFY_MEDIA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [MEDIA_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        messsage: '',
      },
      success: false,
      deleted: false,
      updated: false,
    }),
    [MEDIA_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [MEDIA_BULK]: (state, payload) => ({
      ...state,
      list: payload.medias,
    }),
    // added by me
    [SET_MEDIA]: (state, payload) => ({
      ...state,
      media: payload.media,
    }),
    [ORDER_MEDIA]: (state, payload) => ({
      ...state,
      list: payload.media,
    }),
    [MEDIA_ADD_MEDIA_GROUP]: (state, payload) => ({
      ...state,
      mediaGroup: payload.mediaGroup,
    }),
  },
  initialState
);
